import { ROLE_TYPE } from './types';
import useRequireRole from './useRequireRole';
import useRole from './useRole';

export const useIsAdmin = () => useRole(ROLE_TYPE.ADMIN);
export const useRequireAdmin = () => useRequireRole(ROLE_TYPE.ADMIN);
